import "bootstrap/dist/css/bootstrap.min.css";
import { GlobalStyle } from "./styles/global";
import { AppProvider } from "./hooks/index";
import { HashRouter as Router } from "react-router-dom";
import Routes from "./routes/index";

export function App() {
  return (
    <Router>
      <AppProvider>
        <Routes />
      </AppProvider>
      <GlobalStyle />
    </Router>
  );
}
